// extracted by mini-css-extract-plugin
module.exports = {"grid":"style_grid___fa1D","column":"style_column__1C8eO","row":"style_row__3Ss7m"};